function getProWYXConfig() {
  return {
    projectId: 2, //1魔方，2蜗友行，3熊猫，4放假，5易派客
    platformId: 2, //平台id   总后台0  1魔方 2蜗友行  3熊猫 (短信专用) 5东青
    cloudUrl: 'https://yun.mofangx.com', //测试环境 "https://yun.mofangx.com"
    h5Url: 'https://m.woyoubooking.com',
    newh5Url: 'https://h5-test.woyoubooking.com', // new-h5 域名
    pcShopUrl: 'https://m.woyoubooking.com',
    pcPurchaseUrl: 'http://mp.woyoubooking.com',
    title: '蜗友行管理平台',
    copyText: '蜗友行 版权所有 © 粤ICP备15084969号',
    backUrl: 'admin.woyoubooking.com',
    shortName: '蜗友行'
  }
}

//平台配置数据（各个平台配置数据）
function getPlatformConfig(platformId) {
  if (platformId === 2) {
    return getProWYXConfig()
  }
}

//应用配置数据（所有平台通用）
function getAppConfig() {
  //api包配置信息(链接地址)，默认仅仅配置包名（开发代理使用）
  const proxyOptions = {
    proUrl: '/pro_proxy',
    baseUrl: '/base_proxy',
    apiUrl: '/api_proxy',
    userUrl: '/user_proxy',
    memberAuthUrl: '/memberAuth_proxy',
    serviceUrl: '/service_proxy',
    orderUrl: '/order_proxy',
    permissionUrl: '/permission_proxy',
    payUrl: '/pay_proxy',
    smsUrl: '/sms_proxy',
    newSmsUrl: '/new_sms_proxy',
    sourceUrl: '/source_proxy',
    serveUrl: '/serve_proxy',
    newServeUrl: '/newServe_proxy',
    preSmsUrl: '/preSms_proxy',
    conponUrl: '/coupon_proxy',
    interPayUrl: '/interPay_proxy',
    connUrl: '/conn_proxy',
    resourceUrl: '/resource_proxy',
    webDataUrl: '/webData_proxy',
    shortUrl: '/short_proxy',
    cloudUserUrl: '/cloudUser_proxy',
    cloudProUrl: '/cloudPro_proxy',
    pactUrl: '/pact_proxy',
    cloudOrderUrl: '/cloudOrder_proxy',
    directPresaleUrl: '/directPresale_proxy',
    directTicketsUrl: '/directTickets_proxy',
    pointsUrl: '/integral_proxy'
  }
  return {
    proxyOptions: proxyOptions,
    ...proxyOptions,
    debug: false,
    isDev: process.env.NODE_ENV === 'development', //开发模式,
    supplyChainUrl: 'http://localhost:6678' //供应链页面端口。开发的时候使用
  }
}

export {
  getPlatformConfig,
  getAppConfig
}